export default "__VITE_ASSET__CPCBGZOd__"